import type { EditorCommand } from '@atlaskit/editor-common/types';
import { NodeSelection } from '@atlaskit/editor-prosemirror/state';

import { malleableUiPluginKey } from '../pm-plugins/plugin-key';
import type { RemixModalMetadata } from '../types';

export const openRemixModal =
	(nodePos?: number, metadata?: RemixModalMetadata, source?: string): EditorCommand =>
	({ tr }) => {
		if (nodePos !== undefined) {
			tr.setSelection(NodeSelection.create(tr.doc, nodePos));
		}
		tr.setMeta(malleableUiPluginKey, {
			isRemixModalOpen: true,
			remixModalMetadata: metadata,
			remixSource: source,
		});
		return tr;
	};
